import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { BrandingState } from '../../branding/store/branding.state';
import { BrandingService } from '../../branding/providers/branding.service';
import { filter } from 'rxjs/operators';
import { AsyncPipe } from '@angular/common';
import { CancellationPolicyAgaplesionComponent } from './cancellation-policy-agaplesion/cancellation-policy-agaplesion.component';
import { CancellationPolicyPatientusComponent } from './cancellation-policy-patientus/cancellation-policy-patientus.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-cancellation-policy',
    templateUrl: './cancellation-policy.component.html',
    styleUrls: ['./cancellation-policy.component.scss'],
    imports: [CancellationPolicyAgaplesionComponent, CancellationPolicyPatientusComponent, AsyncPipe, TranslatePipe]
})

export class CancellationPolicyComponent implements OnInit {
    public brandingData$: Observable<BrandingState>;

    constructor(private brandingService: BrandingService) {
    }

    ngOnInit(): void {
        this.brandingData$ =
            this.brandingService.getBrandingSettingsFromStore().pipe(
                filter(e => e !== null && e !== undefined)
            );
    }
}
